import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const detailSectionDefaultVariants = {}
const detailSectionCompoundVariants = []

const detailSectionSlotNames = [
  [
    "root",
    "detail-section__root"
  ],
  [
    "wrapper",
    "detail-section__wrapper"
  ],
  [
    "goto",
    "detail-section__goto"
  ]
]
const detailSectionSlotFns = /* @__PURE__ */ detailSectionSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, detailSectionDefaultVariants, getSlotCompoundVariant(detailSectionCompoundVariants, slotName))])

const detailSectionFn = memo((props = {}) => {
  return Object.fromEntries(detailSectionSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const detailSectionVariantKeys = []
const getVariantProps = (variants) => ({ ...detailSectionDefaultVariants, ...compact(variants) })

export const detailSection = /* @__PURE__ */ Object.assign(detailSectionFn, {
  __recipe__: false,
  __name__: 'detailSection',
  raw: (props) => props,
  variantKeys: detailSectionVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, detailSectionVariantKeys)
  },
  getVariantProps
})